import { getVar } from "config";

export enum ThirdPartyService {
  AWS_APPSYNC = "AWS AppSync",
  CHARGEBEE = "Chargebee",
  DATADOG = "DataDog",
  DATADOG_INTAKE = "DataDog Intake",
  FRESHCHAT = "Freshchat",
  GOOGLE_TAG_MANAGER = "Google Tag Manager",
  MIRO = "Miro",
  SEGMENT = "Segment",
  SPLIT = "Split",
}

export enum ReachabilityTest {
  BILLING = "Billing",
  FEATURE_TOGGLES = "Feature Toggles",
  INTERACTIVE_CONTENT = "Interactive Content",
  SUPPORT_TROUBLESHOOTING = "Support & Troubleshooting",
  USAGE_ANALYTICS = "Usage Analytics",
  WHITEBOARD = "Whiteboard",
}

export const THIRD_PARTY_REACHABILITY_URLS: Record<ThirdPartyService, string> =
  {
    [ThirdPartyService.DATADOG]: "https://api.datadoghq.com",
    [ThirdPartyService.DATADOG_INTAKE]:
      "https://logs.browser-intake-datadoghq.com",
    [ThirdPartyService.FRESHCHAT]: "https://wchat.freshchat.com",
    [ThirdPartyService.GOOGLE_TAG_MANAGER]: "https://www.googletagmanager.com",
    [ThirdPartyService.SPLIT]: "https://sdk.split.io",
    [ThirdPartyService.SEGMENT]: "https://api.segment.io",
    [ThirdPartyService.CHARGEBEE]: "https://chargebee.com",
    [ThirdPartyService.MIRO]: "https://miro.com",
    [ThirdPartyService.AWS_APPSYNC]: getVar("REACT_APP_APP_SYNC_ENDPOINT"),
  };

export const REACHABILITY_TESTS: Record<ReachabilityTest, ThirdPartyService[]> =
  {
    [ReachabilityTest.BILLING]: [ThirdPartyService.CHARGEBEE],
    [ReachabilityTest.USAGE_ANALYTICS]: [
      ThirdPartyService.SEGMENT,
      ThirdPartyService.GOOGLE_TAG_MANAGER,
    ],
    [ReachabilityTest.SUPPORT_TROUBLESHOOTING]: [
      ThirdPartyService.DATADOG,
      ThirdPartyService.DATADOG_INTAKE,
      ThirdPartyService.FRESHCHAT,
    ],
    [ReachabilityTest.FEATURE_TOGGLES]: [ThirdPartyService.SPLIT],
    [ReachabilityTest.WHITEBOARD]: [ThirdPartyService.MIRO],
    [ReachabilityTest.INTERACTIVE_CONTENT]: [ThirdPartyService.AWS_APPSYNC],
  };

export const REACHABILITY_TESTS_MESSAGES: Record<ReachabilityTest, string> = {
  [ReachabilityTest.BILLING]: "micCamCheck:reachability.billing",
  [ReachabilityTest.USAGE_ANALYTICS]:
    "micCamCheck:reachability.usage.analytics",
  [ReachabilityTest.FEATURE_TOGGLES]:
    "micCamCheck:reachability.feature.toggles",
  [ReachabilityTest.SUPPORT_TROUBLESHOOTING]:
    "micCamCheck:reachability.support.troubleshooting",
  [ReachabilityTest.WHITEBOARD]: "micCamCheck:reachability.whiteboard",
  [ReachabilityTest.INTERACTIVE_CONTENT]:
    "micCamCheck:reachability.interactive.content",
};
